module.exports = __webpack_public_path__ + "img/JOAO_PENA.6fb01a91.png";